export const PRIORITY_SORT_MAP = Object.freeze({
  page: 0,
  modal: 1,
  stackedModal: 2, // for a modal stacked on top of another modal
  topModal: 3, // modal that shows on top of any other modal
  max: 10,
});

export const TITLE_DEBOUNCE_TIME = 500;
export const TITLE_LIVE_REGION_TIMEOUT = 8e3;
